import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, Renderer2, ViewChild,} from '@angular/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router,} from '@angular/router';
import {filter, finalize, take} from 'rxjs/operators';
import {DigoService, commissionsGuard} from './services/digo.service';
import {environment, iaAssistantLink} from '../environments/environment';
import {MatDialog} from '@angular/material/dialog';
import {AlertDialogComponent} from './shared/components/alert-dialog/alert-dialog.component';
import {Subscription} from 'rxjs';
import {HomeService} from './home/services/home.service';
import * as moment from 'moment/moment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { PermissionService } from './shared/services/permission.service';
import { Ipdv } from './shared/models/pdvResponse';
import { SimyoTemporaryClosureComponent } from './simyo/components/simyo-temporary-closure/simyo-temporary-closure.component';
import { HttpErrorResponse } from '@angular/common/http';
import { allPermissions } from './shared/permissions';
import { BannerComponent } from './home/components/hm-points/modals/banner/banner.component';
import { CookieService } from './home/services/cookie.service';
import { PointsService } from './home/services/points.service';
import { AcceptedPointsProgramComponent } from './home/components/hm-points/modals/accepted-points-program/accepted-points-program.component';
import { allSessionStorage, setContractType, stepsShowRatesByBrand, tabHome } from './shared/constantes';
import { SimyoAppointmentService } from './simyo/services/simyo-appointment.service';
import { MyaddressService } from './services/myaddress.service';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HmModalCommissionsComponent } from './home/components/hm-modal-commissions/hm-modal-commissions.component';
import { BannerPromoComponent } from './home/modals/banner-promo/banner-promo.component';
import { AuthService } from './shared/services/auth.service';
import { FirebaseService } from './services/firebase.service';
import { ChatService } from './home/services/chat.service';
import { ChatSoporteService } from './home/services/chat-soporte.service';
import { HmModalContractConditionsComponent } from './home/components/hm-modal-contract-conditions/hm-modal-contract-conditions.component';
import { TracerService } from './services/tracer.service';
import { HmInfoModalComponent } from './home/components/hm-info-modal/hm-info-modal.component';
import { shouldShowSimyoEarthquakePopup } from './home/components/hm-info-modal/simyo-earthquake-popup.util';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements AfterViewInit, OnDestroy, OnInit {
    @ViewChild('simyoNotAvailableModal') simyoNotAvailableModal: NgbModalRef;
    title = 'nuevoFrontal';
    actualUrl: string;
    pdv: any;
    public loadIframeMode = false;
    public prevUrl: string = '';
    public today = moment();
    public ultimoBlur = null;
    public tiempoInactivo = 0;
    public chatIsAvailable = false;
    public chatSoporteIsAvailable = false;
    // Fechas para bloquar Simyo
    // public fromSimyoNotAvailable = moment('2021-06-11 20:30:00');
    // public untilSimyoNotAvailable = moment('2021-06-12 09:30:00');
    private allSubscription: Subscription[] = [];
    private commissionsTamperInterval: ReturnType<typeof setInterval> | null = null;
    private commissionsMutationObserver: MutationObserver | null = null;
    private contractConditionsTamperInterval: ReturnType<typeof setInterval> | null = null;
    private contractConditionsMutationObserver: MutationObserver | null = null;
    private simyoUrlsBlocked = [
        '/simyo/convergente',
        '/simyo/solo-movil',
        '/simyo/solo-fibra',
        '/simyo/duplicados',
    ];
    private operationLimitNightUrlsBlocked = [
        '/simyo',
        'republica-movil',
        '/amena',
    ];

    responseCommissions: any;
    responseContractConditions: any;

    private iaLink = iaAssistantLink;
    public allPermissions = allPermissions;

    get baseUrl(): string {
        return this.authService.getLegacyBaseUrl();
    }

    /** Alias Legacy: detección de URLs demo hacia el servidor Legacy. */
    get digoEndpoint(): string {
        return this.authService.getLegacyBaseUrl();
    }

    get isAsistentIaRoute(): boolean {
        return this.router.url.includes('/asistent-ia') || this.router.url.includes('asistent-ia');
    }

    constructor(
        public router: Router,
        public matDialog: MatDialog,
        public permSv: PermissionService,
        public digoService: DigoService,
        private route: ActivatedRoute,
        private homeService: HomeService,
        private modalService: NgbModal,
        private _location: Location,
        private cookieService: CookieService,
        private pointsService: PointsService,
        public simyoAppointmentService: SimyoAppointmentService,
        private myaddressService: MyaddressService,
        public authService: AuthService,
        private firebaseService: FirebaseService,
        private chatService: ChatService,
        private renderer: Renderer2,
        private tracerService: TracerService,
        private chatSoporteService: ChatSoporteService
    ) {
        this.myaddressService.interceptFetchRequests();

        // Se añade el guard del modal de comisionado
        this.router.config.forEach(route => {
            route.canActivate = route.canActivate ? [...route.canActivate, commissionsGuard] : [commissionsGuard];
            route.canActivateChild = route.canActivateChild ? [...route.canActivateChild, commissionsGuard] : [commissionsGuard];
            route.canDeactivate = route.canDeactivate ? [...route.canDeactivate, commissionsGuard] : [commissionsGuard];
        });

        this.route.queryParams.subscribe((params) => {
            sessionStorage.setItem(
                'showInfoCustomer',
                (params.info_customer != null &&
                    (params.info_customer === '1' ||
                        params.info_customer === 1)) ||
                (sessionStorage.getItem('showInfoCustomer') &&
                    sessionStorage.getItem('showInfoCustomer') === '1')
                    ? '1'
                    : '0'
            );
        });

        router.events
            .pipe(
                filter(
                    (event) =>
                        event instanceof NavigationStart ||
                        event instanceof NavigationEnd
                )
            )
            .subscribe((event: any) => {
                if (event instanceof NavigationStart) {
                    // Gestión de los datos si nos movemos de operaciones al detalle de un pedido y viceversa
                    if (
                        !(
                            (this.prevUrl === '/' &&
                                (event.url.includes('simyo/order') ||
                                    event.url.includes(
                                        'orange/bonos-adicionales-order'
                                    ) ||
                                    event.url.includes(
                                        'orange/prepago-order'
                                    ) ||
                                    event.url.includes(
                                        'republica-movil/order'
                                    ))) ||
                            (event.url === '/' &&
                                (this.prevUrl.includes('simyo/order') ||
                                    this.prevUrl.includes(
                                        'orange/bonos-adicionales-order'
                                    ) ||
                                    this.prevUrl.includes(
                                        'orange/prepago-order'
                                    ) ||
                                    this.prevUrl.includes(
                                        'republica-movil/order'
                                    )))
                        )
                    ) {
                        this.homeService.setNavigateFromOperationPosVenta(null);
                        this.homeService.setNavigateFromOperation(null);
                    }
                    this.actualUrl = event.url;
                    if (event.id === 1) {
                        if (!this.actualUrl.includes('jwt')) {
                            this.callPdvData();
                        }
                    } else {
                        this.checkPermissions();
                    }

                    if(event.url.includes('simyo/solo-movil')) {
                        setContractType('mobile');
                    }
                    if(event.url.includes('simyo/convergent')) {
                        setContractType('convergent');
                    }
                }

                if (event instanceof NavigationEnd) {
                    if (
                        this.prevUrl &&
                        this.prevUrl.includes('frame=true') &&
                        !event.url.includes('frame=true')
                    ) {
                        this.router.navigate([event.url], {
                            relativeTo: this.route,
                            queryParams: {frame: true},
                        });
                    }
                    this.prevUrl = event.url;
                }
            });

        route.queryParams.subscribe((params) => {
            if (
                params &&
                params.frame &&
                params.frame === 'true' &&
                this.actualUrl.includes('simyo')
            ) {
                this.loadIframeMode = true;
            }
        });

        this.allSubscription.push(
            this.digoService.openCommissionsModal$.subscribe((payload) => {
                this.responseCommissions = payload.responseCommissions;
                this.openCommissionsModal();
            })
        );

        // Comprueba si tiene que abrir el modal de condiciones de contrato
        this.allSubscription.push(
            this.digoService.openContractConditionsModal$.subscribe((payload) => {
                this.responseContractConditions = payload.responseContractConditions;
                this.openContractConditionsModal();
            })
        );

        // this.openContractConditionsModal();


        this.allSubscription.push(
            this.digoService.getRenewPDV().subscribe((data: any) => {
                if (data != null && data === true) {
                    this.digoService.setRenewPDV(false);
                    this.digoService.resetCommissionsCheck();
                    this.digoService.resetConditionsContractCheck();
                    this.callPdvData(true);
                }
            })
        );

        setInterval(() => {
            this.digoService.keepAlive().subscribe({
                next: (resp: any) => {
                    if (!resp || resp !== 200) {
                        this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive, resp: ' + resp + ' - app.component - intervalKeepAlive');
                        this.digoService.goLogin();
                    }
                },
                error: (error: HttpErrorResponse) => {
                    this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive Error response: ' + error.message + ' - app.component - intervalKeepAlive');
                    this.digoService.goLogin();
                },
                complete: () => {
                },
            });
        }, 300000); //5 minutos, 300000 milisegundos.

        let appointment_date = localStorage.getItem('appointment');
        if (appointment_date) {
            let appointment = JSON.parse(appointment_date);
            this.simyoAppointmentService
                .cancel(appointment.id, appointment.order_id)
                .pipe(
                    finalize(() => {
                        localStorage.removeItem('appointment');
                    })
                ).subscribe();
        }
    }

    ngOnInit() {
        if (this.tracerService.isActive) {
            // 1. Escuchar Clicks (como antes)
            this.renderer.listen('document', 'click', (event: MouseEvent) => {
              this.trackClick(event);
            });

            // 2. Escuchar FOCUS (Saber dónde entra el usuario)
            // Usamos 'true' al final para activar la fase de captura, ya que focus/blur no burbujean normalmente
            this.renderer.listen('document', 'focus', (event: FocusEvent) => {
              this.trackFocus(event);
            });

            // 3. Escuchar BLUR (Saber qué escribió al salir)
            this.renderer.listen('document', 'blur', (event: FocusEvent) => {
              this.trackBlur(event);
            });
          }
      }

    // @HostListener('window:focus', ['$event'])
    @HostListener('window:focus')
    onFocus(): void {
        if (this.ultimoBlur !== null && this.ultimoBlur._isValid) {
            this.ultimoBlur = moment().diff(this.ultimoBlur) / 60000;
            if (this.ultimoBlur >= 20) {
                this.digoService.goLogin();
            }
        }
    }

    // @HostListener('window:blur', ['$event'])
    @HostListener('window:blur')
    onBlur(): void {
        this.ultimoBlur = moment();
    }

    ngAfterViewInit() {
        this.liveQuery('a', 'click', (event, element) => {
            if (element && element.getAttribute('href')) {
                this.checkExternalNavigation(
                    event,
                    element.getAttribute('href')
                );
            }
        });
    }

    callPdvData(fromRenew = false) {
        this.digoService.getPdvFromService().subscribe((data: Ipdv) => {
            if (data.info.idpdv.toString().includes('XML:')) {
                data.permissions.AMENA = 'TUVO_ACTIVACIONES';
                data.permissions.RENOVACION_ANTICIPADA_BONOS =
                    'BLOQUEAR_RENOVACION_DE_BONOS_ANTICIPADA';
                data.permissions.SIMYO_DUPLICADOS_DE_SIM =
                    'BLOQUEAR_DUPLICADOS';
            }

            this.digoService.setPDV(data);
            this.pdv = data;
            this.checkPermissions();
            if (this.permSv.hasPermFromV2(allPermissions.others.comissions_not_blocked)) {
                this.allSubscription.push(
                    this.digoService.checkCommissionsOnce(data).subscribe((outcome) => {
                        if (
                            this.actualUrl === '/' &&
                            !outcome?.redirectedToComisionEmpresa
                        ) {
                            this.showPopupSimyoColombiaEarthquake();
                        }
                    })
                );
                // Punto 3: forzar re-evaluación tras renew (p. ej. cierre de comisiones)
                if (fromRenew) {
                    this.digoService.resetConditionsContractCheck(); // opcional
                }
                this.allSubscription.push(
                    this.digoService.checkConditionsContractOnce(data).subscribe()
                );
            } else if (this.actualUrl === '/') {
                this.showPopupSimyoColombiaEarthquake();
            }

            this.registerFcmToken();
            if (this.actualUrl == '/') {
                this.showBannerPoints();
                this.showBannerPromo();
            }
            if (this.pdv?.info?.isCSQ) {
                this.router.navigate(['/simyo/solo-movil']);
            }
        });
    }

    checkPermissions() {
        if (this.pdv) {
            if (
                (this.actualUrl.includes('amena') && !this.permSv.hasPermFromV2(allPermissions.amena.permite_activaciones)) ||
                (this.actualUrl.includes('amena') && environment.production && !this.permSv.hasPermFromV2(allPermissions.amena.patch_old_amena)) ||
                (this.actualUrl.includes('republica-movil') && !this.permSv.hasPermFromV2(allPermissions.rep_movil.permite_ventas) && !(this.actualUrl.includes('listado') || this.actualUrl.includes('order')) && this.permSv.hasPermFromV2(allPermissions.rep_movil.tuvo_activaciones)) ||
                (this.actualUrl.includes('simyo') && (this.permSv.hasPermFromV2(allPermissions.simyo.bloquea_ventas) || !this.permSv.hasPermFromV2(allPermissions.simyo.permite_ventas_nuevo_frontal) && !(this.actualUrl.includes('listado') || this.actualUrl.includes('order')) && this.permSv.hasPermFromV2(allPermissions.simyo.tuvo_activaciones)))
            ) {
                this.router.navigate(['/']);
                console.log(
                    'No tiene permisos para ingresar a esta zona. Redirigiendo a Home'
                );
            }
        }

        if (this.simyoUrlsBlocked.includes(this.actualUrl) && this.permSv.hasPermFromV2(allPermissions.simyo.nbss_block)) {
            this.modalService.open(SimyoTemporaryClosureComponent, {size: 'lg', centered: true, backdrop: 'static'});
            this.router.navigate(['/']);
        }
        /* Bloquear Simyo durante un periodo de tiempo limitado
        if (
            this.today.isSameOrAfter(this.fromSimyoNotAvailable) && this.today.isBefore(this.untilSimyoNotAvailable) &&
            (this.actualUrl === '/simyo/solo-movil' ||
            this.actualUrl === '/simyo/convergente' ||
            this.actualUrl === '/simyo/solo-fibra' ||
            this.actualUrl === '/simyo/tarifas')
        ) {
            this.modalService.open(this.simyoNotAvailableModal, {size: 'md', centered: true, backdrop: 'static', keyboard : false});
        }
        */

        if (this.permSv.hasPermFromV2(allPermissions.others.access_night) === false && this.operationLimitNightUrlsBlocked.some(url => this.actualUrl.includes(url))) {
            this.router.navigate(['/']);
        }

        this.chatIsAvailable = this.permSv.hasPermFromV2(allPermissions.others.chat);
        // Misma condición que home: si el icono es visible, el widget debe estar montado
        this.chatSoporteIsAvailable =
            this.permSv.hasPermFromV2(allPermissions.others.chat_soporte_pdv);
    }

    checkExternalNavigation(event, url) {
        if (this.permSv.hasPermFromV2(allPermissions.others.users_demo) && url.includes(this.digoEndpoint) && !url.includes('signin.itx?ac=999')) {
            let message = 'Usuario demostración. Función no disponible';

            if (url.includes('seguridad.itx')) {
                message =
                    'Usuario demostración. No se puede cambiar la contraseña';
            }

            event.preventDefault();
            this.matDialog.open(AlertDialogComponent, {
                data: {message},
            });
        }
    }

    liveQuery(selector, eventType, callback, context = null) {
        (context || document).addEventListener(
            eventType,
            (event) => {
                const nodeList = document.querySelectorAll(selector);
                const matches = [];

                nodeList.forEach((nodeItem) => matches.push(nodeItem));

                if (matches) {
                    let element = event.target;
                    let index: any = -1;

                    while (
                        element &&
                        (index = matches.indexOf(element) === -1)
                        ) {
                        element = element.parentElement;
                    }

                    if (index > -1) {
                        callback.call(element, event, element);
                    }
                }
            },
            false
        );
    }

    backClicked() {
        this._location.back();
    }

    ngOnDestroy() {
        this.stopCommissionsTamperWatch();
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map((subs) => subs.unsubscribe());
        }
    }

    showBannerPoints() {
        if (this.permSv.hasPermFromV2(allPermissions.others.access_points) && this.pointsService.checkIsAcceptedPointsProgram(this.pdv.info.points_terms) === false) {
            let cookieShowBannerPoints = this.cookieService.getCookie('showBannerPoints');
            let showBannerPoints = this.checkIsJson(cookieShowBannerPoints) ? JSON.parse(cookieShowBannerPoints) : {};
            if (showBannerPoints.hasOwnProperty(this.pdv.info.username)) {
                showBannerPoints[this.pdv.info.username] = ++showBannerPoints[this.pdv.info.username];
            } else {
                showBannerPoints[this.pdv.info.username] = 1;
            }
            this.cookieService.setCookie({
                name: 'showBannerPoints',
                value: JSON.stringify(showBannerPoints),
                session: true,
            });
            if (showBannerPoints[this.pdv.info.username] <= 5) {
                const dialogRef = this.matDialog.open(BannerComponent, {
                    backdropClass: 'md-backdrop',
                    maxWidth: 800,
                    panelClass: 'md-container-white',
                    width: '100%',
                });
                dialogRef
                    .afterClosed()
                    .pipe(take(1))
                    .subscribe((result) => {
                        if (result === true) {
                            this.homeService.setGoToTab(tabHome.PUNTOS);
                        }
                    });
                return;
            }
        }
    }

    showBannerPromo() {
        const today = new Date();
        const startDate = new Date('2025-07-01');
        const endDate = new Date('2025-07-31');
        const allowedPdvs = [4, 54264, 44345, 54953, 56351, 52003, 56276, 45487, 53653, 49240, 58875, 44954, 58839, 52072, 52240, 56484, 47301, 48692, 50754, 57673, 57242, 54147, 24895, 52052, 57094, 39163, 15258, 45743, 23695, 47625, 57735, 26964, 23696, 56699, 60198, 16222, 55682, 47792, 40073, 56577, 43613, 58640, 48869, 44898, 46593, 46040, 44595, 46312, 44826, 43223, 57338, 52808, 58374, 40699, 53332, 43520, 20690, 669, 49980, 55845, 46247, 53627, 56872, 40961, 55881, 60171, 50517, 50639, 47031, 23694, 21365, 55311, 46845, 58893, 48327, 56299, 25314, 13528, 58664, 58861, 57736, 45528, 54885, 50128, 58662, 38037, 52128, 54918, 56920, 57892, 38974, 51947, 56291, 53056, 47887, 58328, 22224, 52505, 34597, 57250, 55582, 57843, 47003, 13551, 53555, 57698, 55360, 57278, 58624, 52606, 47406, 57675, 56713, 39241, 53120, 48696, 54327, 60110, 56747, 58510, 43794, 53543, 40756, 31699, 54880, 57738, 37330, 45579, 58646, 47951, 6322, 58847, 26032, 49802, 49298, 54700, 54704, 44316, 36950, 60177, 60125, 14064, 57352, 47808, 54909, 57681, 56223, 40621, 52263, 53650, 58549, 57189, 22482, 54780, 44922, 56259, 53641, 54082, 49207, 49880, 56988, 46643, 31684, 56425, 60313, 51182, 53418, 45489, 57782, 20370, 44535, 50632, 56656, 56500, 54768, 57317, 58338, 60210, 58667, 58434, 31476, 44736, 43726, 45761, 57678, 45661, 39410, 54211, 57697, 45674, 56894, 54762, 45793, 48333, 54058, 57282, 57730, 56395, 56709, 45709, 47957, 48438, 57000, 48533, 55443, 44969, 45920, 60206, 52155, 20119, 53084, 5327, 23161, 57941, 35353, 51815, 23484, 57728, 57419, 55088, 35688, 20686, 57379, 17051, 45984, 22165, 50284, 56746, 42562, 6792, 52627, 57047, 41066, 43682, 60165, 52255, 32385, 47210, 55584, 56384, 50946, 57707, 58658, 52981, 51102, 38575, 58340, 15297, 15402, 57033, 57729, 54554, 57142, 56672, 56730, 52892, 56620, 57098, 45567, 36870, 50698, 55589, 56931, 44988, 46448, 49961, 55954, 55408, 60248, 45653, 56655, 53676, 53630, 45930, 44607, 56647, 49301, 56227, 17717, 57767, 14652, 50845, 46469];
        if (today >= startDate && today <= endDate && allowedPdvs.includes(this.pdv.info.idpdv)) {
            let cookieShowBannerPromo = this.cookieService.getCookie('showBannerPromo');
            let showBannerPromo = this.checkIsJson(cookieShowBannerPromo) ? JSON.parse(cookieShowBannerPromo) : {};
            if (showBannerPromo.hasOwnProperty(this.pdv.info.username)) {
                showBannerPromo[this.pdv.info.username] = ++showBannerPromo[this.pdv.info.username];
            } else {
                showBannerPromo[this.pdv.info.username] = 1;
            }
            this.cookieService.setCookie({
                name: 'showBannerPromo',
                value: JSON.stringify(showBannerPromo),
                session: true,
            });
            if (showBannerPromo[this.pdv.info.username] <= 1) {
                this.matDialog.open(BannerPromoComponent, {
                    backdropClass: 'md-backdrop',
                    maxWidth: 800,
                    panelClass: ['md-container-white', 'promo-modal-container'],
                    width: '100%',
                });
                // dialogRef
                //     .afterClosed()
                //     .pipe(take(1))
                // .subscribe((result) => {
                //     if(result === true) this.homeService.setGoToTab(tabHome.PUNTOS);
                // });
                return;
            }
        }
    }

    private checkIsJson(data) {
        const jsonRegex = /^\s*{\s*".*"\s*:\s*.*\s*}\s*$/;
        return jsonRegex.test(data);
    }

    public hasOneDayPassed(lastShownTime: string): boolean {
        const lastShownDate = new Date(lastShownTime);
        const now = new Date();
        const timeDiff = now.getTime() - lastShownDate.getTime();
        return timeDiff > 24 * 60 * 60 * 1000; // 24 horas en milisegundos
    }

    openCommissionsModal() {
        if (!this.digoService.isCommissioned) {
            return;
        }

        if (document.querySelector('app-hm-modal-commissions')) {
            this.startCommissionsTamperWatch();
            return;
        }

        this.responseCommissions =
            this.responseCommissions ?? this.digoService.responseCommissions;

        const modalRef = this.modalService.open(HmModalCommissionsComponent, {
            size: 'xl',
            centered: true,
            backdrop: 'static',
            keyboard: false,
            windowClass: 'commissions-modal-width'
        });

        modalRef.componentInstance.pdv = this.pdv;
        modalRef.componentInstance.responseCommissions = this.responseCommissions;
        this.startCommissionsTamperWatch();
    }

    checkAndReopenModal() {
        if (!this.digoService.isCommissioned) {
            return;
        }

        const modalElement = document.querySelector('app-hm-modal-commissions');
        if (!modalElement) {
            this.modalService.dismissAll();
            setTimeout(() => {
                if (this.digoService.isCommissioned) {
                    this.openCommissionsModal();
                }
            }, 100);
        }
    }

    private startCommissionsTamperWatch(): void {
        if (this.commissionsTamperInterval || this.commissionsMutationObserver) {
            return;
        }

        this.commissionsTamperInterval = setInterval(() => {
            if (this.digoService.isCommissioned) {
                this.checkAndReopenModal();
            } else {
                this.stopCommissionsTamperWatch();
            }
        }, 500);

        this.commissionsMutationObserver = new MutationObserver(() => {
            if (this.digoService.isCommissioned) {
                this.checkAndReopenModal();
            }
        });
        this.commissionsMutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    private stopCommissionsTamperWatch(): void {
        if (this.commissionsTamperInterval) {
            clearInterval(this.commissionsTamperInterval);
            this.commissionsTamperInterval = null;
        }
        if (this.commissionsMutationObserver) {
            this.commissionsMutationObserver.disconnect();
            this.commissionsMutationObserver = null;
        }
    }

    async registerFcmToken() {
        const pdvId = this.pdv?.info?.idpdv;
        if (!pdvId) {
            return;
        }

        // Recalcular en el momento del registro (CHAT_SOPORTE_PDV === PERMITIR)
        const canChatSoporte = this.permSv.hasPermFromV2(allPermissions.others.chat_soporte_pdv);
        this.chatSoporteIsAvailable = canChatSoporte;
        this.chatIsAvailable = this.permSv.hasPermFromV2(allPermissions.others.chat);

        if (!this.chatIsAvailable && !canChatSoporte) {
            return;
        }

        const fcmToken = await this.firebaseService.registerMessagingToken();
        if (!fcmToken) {
            return;
        }

        const body = {token: fcmToken, id_pdv: pdvId};

        // Un solo register: chat y chat-soporte comparten el mismo BE/token FCM;
        // llamar ambos se pisa. Preferimos chat; si solo hay soporte, ese endpoint.
        if (this.chatIsAvailable) {
            this.chatService.registerFcmToken(body).subscribe();
        } else if (canChatSoporte) {
            this.chatSoporteService.registerFcmToken(body).subscribe();
        }
    }

    openContractConditionsModal() {
        if (!this.digoService.isConditionsContractSigned) {
            return;
        }

        if (document.querySelector('app-hm-modal-contract-conditions')) {
            this.startContractConditionsTamperWatch();
            return;
        }

        this.responseContractConditions =
            this.responseContractConditions ?? this.digoService.responseContractConditions;

        const modalRef = this.modalService.open(HmModalContractConditionsComponent, {
            size: 'xl',
            centered: true,
            backdrop: 'static',
            keyboard: false,
            windowClass: 'contract-conditions-modal'
        });

        // Inputs que van a llegarle al modal
        modalRef.componentInstance.pdv = this.pdv;
        modalRef.componentInstance.responseContractConditions = this.responseContractConditions;
        this.startContractConditionsTamperWatch();
    }

    checkAndReopenContractConditionsModal() {
        if (!this.digoService.isConditionsContractSigned) {
            return;
        }

        const modalElement = document.querySelector('app-hm-modal-contract-conditions');
        if (!modalElement) {
            this.modalService.dismissAll();
            setTimeout(() => {
                if (this.digoService.isConditionsContractSigned) {
                    this.openContractConditionsModal();
                }
            }, 100);
        }
    }

    private startContractConditionsTamperWatch(): void {
        if (this.contractConditionsTamperInterval || this.contractConditionsMutationObserver) {
            return;
        }

        this.contractConditionsTamperInterval = setInterval(() => {
            if (this.digoService.isConditionsContractSigned) {
                this.checkAndReopenContractConditionsModal();
            } else {
                this.stopContractConditionsTamperWatch();
            }
        }, 500);

        this.contractConditionsMutationObserver = new MutationObserver(() => {
            if (this.digoService.isConditionsContractSigned) {
                this.checkAndReopenContractConditionsModal();
            }
        });
        this.contractConditionsMutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    private stopContractConditionsTamperWatch(): void {
        if (this.contractConditionsTamperInterval) {
            clearInterval(this.contractConditionsTamperInterval);
            this.contractConditionsTamperInterval = null;
        }
        if (this.contractConditionsMutationObserver) {
            this.contractConditionsMutationObserver.disconnect();
            this.contractConditionsMutationObserver = null;
        }
    }

    private trackClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const buttonOrLink = target.closest('button, a, [role="button"]'); // Centrado en elementos de acción

        if (buttonOrLink) {
            const info = buttonOrLink.getAttribute('data-tracer') || buttonOrLink.textContent || buttonOrLink.id;
            if (info) this.tracerService.logAction(`CLICK en: ${info.trim()}`);
        }
    }

    private trackFocus(event: FocusEvent) {
        const target = event.target as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

        if (target && ['INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName)) {
          // 💡 Comprobamos si 'placeholder' existe en este target específico
          const placeholderText = ('placeholder' in target) ? (target as any).placeholder : '';

          const info = target.getAttribute('data-tracer') || placeholderText || target.id || target.name || 'campo sin nombre';

          this.tracerService.logAction(`FOCO EN: [${target.tagName}] ${info.trim()}`);
        }
    }

    private trackBlur(event: FocusEvent) {
        const target = event.target as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

        if (target && ['INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName)) {
            const info = target.getAttribute('data-tracer') || target.id || target.name || 'campo sin nombre';

            // Obtenemos el valor actual del input
            let valor = target.value;

            // Si es un password, por seguridad no lo guardes en el log
            if (target.type === 'password') {
            valor = '********';
            }

            this.tracerService.logAction(`VALOR GUARDADO en [${info.trim()}]: "${valor}"`);
        }
    }
    
    // Abrir IA Assistant en una nueva pestaña (puente /asistent-ia evita bloqueo de popups)
    openIAAssistant(): void {
        if (!this.iaLink) {
            return;
        }
        // Síncrono en el click para evitar el bloqueo de popups del navegador
        window.open('/asistent-ia', '_blank', 'noopener,noreferrer');
    }

    showPopupSimyoColombiaEarthquake(): void {

        // Se oculta modal de simyo para el terremoto de Colombia por ahora. Para volver a mostrarlo, quitar este return y descomentar el código de abajo.
        return;

        // INFO: Descomentar para mostrar
        
        // const alreadyShown = sessionStorage.getItem(allSessionStorage.simyoEarthquakeCoShown) != null;

        // if (!shouldShowSimyoEarthquakePopup({
        //         hasSimyoPerm: this.permSv.hasPermFromV2(allPermissions.simyo.permite_vender),
        //         alreadyShownInSession: alreadyShown,
        //         hasOpenMatDialogs: this.matDialog.openDialogs.length > 0,
        //     })
        // ) {
        //     return;
        // }

        // sessionStorage.setItem(allSessionStorage.simyoEarthquakeCoShown, '1');

        // this.matDialog.open(HmInfoModalComponent, {
        //     backdropClass: 'md-backdrop',
        //     maxWidth: 800,
        //     panelClass: 'md-container-white',
        //     width: '100%',
        //     data: {
        //         title: 'Aviso urgente: Servicio al canal simyo temporalmente suspendido',
        //         body:
        //             'Servicio al canal de simyo, no podrá atenderte debido a una situación excepcional provocada por un terremoto en Colombia, que está afectando a nuestros equipos de servicio al canal.\n\n' +
        //             'Sentimos mucho las molestias que esto pueda ocasionarte. Te invitamos a volver a contactar con nosotros pasados unos días, cuando esperamos haber recuperado la normalidad en nuestro servicio de atención.\n\n' +
        //             'Gracias por tu comprensión.',
        //     },
        // });
    }

}
